import React, { useState } from "react";
import { Button } from "@mui/material";
import "./UserFields.css";

const UserFields = ({
  onCreateUser,
  title = "",
  onClose,
  cancelLabel = "Cancel",
  submitLabel = "Create User",
}) => {
  const [givenName, setGivenName] = useState("");
  const [familyName, setFamilyName] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const nameRegex = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const validate = () => {
    const newErrors = {};

    const trimmedGivenName = givenName.trim();
    const trimmedFamilyName = familyName.trim();
    const trimmedEmail = email.trim();

    if (!nameRegex.test(trimmedGivenName)) newErrors.givenName = "*First name can only contain letters and single spaces between names.";
    else setGivenName(trimmedGivenName);

    if (!nameRegex.test(trimmedFamilyName)) newErrors.familyName = "*Last name can only contain letters and single spaces between names.";
    else setFamilyName(trimmedFamilyName);

    if (!emailRegex.test(trimmedEmail)) newErrors.email = "*Please enter a valid email address.";
    else setEmail(trimmedEmail);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleBlur = (field) => {
    const newErrors = { ...errors };

    if (field === "givenName") {
      if (givenName === "") delete newErrors.givenName;
      else if (givenName !== givenName.trim()) newErrors.givenName = "*No leading or trailing whitespace allowed.";
      else if (!nameRegex.test(givenName.trim())) newErrors.givenName = "*Only letters and single spaces allowed.";
      else delete newErrors.givenName;
    } else if (field === "familyName") {
      if (familyName === "") delete newErrors.familyName;
      else if (familyName !== familyName.trim()) newErrors.familyName = "*No leading or trailing whitespace allowed.";
      else if (!nameRegex.test(familyName.trim())) newErrors.familyName = "*Only letters and single spaces allowed.";
      else delete newErrors.familyName;
    } else if (field === "email") {
      if (email === "") delete newErrors.email;
      else if (email !== email.trim()) newErrors.email = "*No leading or trailing whitespace allowed.";
      else if (!emailRegex.test(email.trim())) newErrors.email = "*Please enter a valid email address.";
      else delete newErrors.email;
    }

    setErrors(newErrors);
  };

  const handleNameChange = (field, value) => {
    const keystrokeNameRegex = /^[A-Za-z\s]*$/;
    if (!keystrokeNameRegex.test(value)) {
      setErrors((prev) => ({ ...prev, [field]: "*Only letters and spaces allowed." }));
    } else {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      });
    }

    if (field === "givenName") setGivenName(value);
    if (field === "familyName") setFamilyName(value);
  };

  const handleEmailChange = (value) => {
    const keystrokeEmailRegex = /^[A-Za-z0-9@._+\-\s]*$/;
    if (!keystrokeEmailRegex.test(value)) {
      setErrors((prev) => ({ ...prev, email: "*Invalid character in email address." }));
    } else {
      setErrors((prev) => {
        const next = { ...prev };
        delete next.email;
        return next;
      });
    }
    setEmail(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const newUser = { givenName, familyName, email };
      console.log("Sending new user:", newUser);
      onCreateUser(newUser);

      setGivenName("");
      setFamilyName("");
      setEmail("");
      setErrors({});
    }
  };

  const hasCancel = typeof onClose === "function";

  return (
    <div className="user-fields-container">
      {title ? (
        <div className="user-fields-header">
          <div className="user-fields-title">{title}</div>
        </div>
      ) : null}

      <form className="user-fields-form" onSubmit={handleSubmit}>
        <div className={`form-group ${errors.givenName ? "error-input" : ""}`}>
          <input
            id="first_name"
            placeholder="Enter first name"
            className="input-field"
            value={givenName}
            onChange={(e) => handleNameChange("givenName", e.target.value)}
            onBlur={() => handleBlur("givenName")}
            required
          />
          {errors.givenName && <span className="error-message">{errors.givenName}</span>}
        </div>

        <div className={`form-group ${errors.familyName ? "error-input" : ""}`}>
          <input
            id="last_name"
            placeholder="Enter last name"
            className="input-field"
            value={familyName}
            onChange={(e) => handleNameChange("familyName", e.target.value)}
            onBlur={() => handleBlur("familyName")}
            required
          />
          {errors.familyName && <span className="error-message">{errors.familyName}</span>}
        </div>

        <div className={`form-group ${errors.email ? "error-input" : ""}`}>
          <input
            id="email"
            placeholder="Enter email"
            className="input-field"
            value={email}
            onChange={(e) => handleEmailChange(e.target.value)}
            onBlur={() => handleBlur("email")}
            required
            type="email"
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <div className={`user-fields-footer ${hasCancel ? "user-fields-footer--two" : "user-fields-footer--one"}`}>
          {hasCancel && (
            <Button
              variant="outlined"
              onClick={onClose}
              fullWidth
              className="user-fields-btn user-fields-btn--cancel"
            >
              {cancelLabel}
            </Button>
          )}

          <Button
            type="submit"
            variant="contained"
            disableElevation
            fullWidth
            className="user-fields-btn user-fields-btn--primary"
          >
            {submitLabel}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default UserFields;
